"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLIT = void 0;
exports.SPLIT = {
    alias: 'SPLIT',
    description: 'Divide o @texto pelo @separador e retorna a parte encontrada na @posicao',
    arg_names: ['texto', 'separador', 'posicao'],
    args_description: [
        'texto que será dividido',
        'o separador que divide as partes do texto',
        'a posicao que será retornada (0 por padrão). caso não encontrado ou não enviado, retornará vazio',
    ],
};
